import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Container, Form, Button, Alert } from 'react-bootstrap';
import API from '../../services/api';
import { t } from "@lingui/macro";

const RegisterForm = () => {
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [showForm, setShowForm] = useState(true);

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
      username: '',
      firstName: '',
      lastName: '',
      phoneNumber: '',
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email(t`Invalid email format`)
        .required(t`Email is required`),
      password: Yup.string()
        .min(5, t`Password must be at least 5 characters long`)
        .required(t`Password is required`),
      username: Yup.string()
        .min(3, t`Username must be at least 3 characters long`)
        .required(t`Username is required`),
      phoneNumber: Yup.string()
        .matches(/^\d{9,10}$/, t`Phone number must be 9 or 10 digits long`)
        .nullable(),
    }),
    onSubmit: async (values) => {
      try {
        const response = await API.post('/api/auth/public/register', values);

        setSuccessMessage(t`User registered successfully!`);
        setShowForm(false);

        setTimeout(() => {
          window.location.href = '/home';
        }, 3000);
      } catch (err) {
        if (err.response) {
          setErrorMessage(err.response.data.errorMessage || t`Registration failed`);
        } else {
          setErrorMessage(t`An unexpected error occurred.`);
        }
        setShowForm(true);
      }
    },
  });

  return (
    <Container className="mt-5 form-container">
      <h2 className="text-center">{t`Register`}</h2>

      {successMessage && (
        <Alert variant="success" className="alert">{successMessage}</Alert>
      )}
      {errorMessage && (
        <Alert variant="danger" className="alert">{errorMessage}</Alert>
      )}

      {showForm && (
        <Form onSubmit={formik.handleSubmit} className="form-content">
          <Form.Group controlId="email" className="mb-3">
            <Form.Label className="form-label">
              {t`Email`} <span className="required">*</span>
            </Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              isInvalid={formik.touched.email && formik.errors.email}
              className="form-control"
            />
            <Form.Control.Feedback type="invalid" className="form-control-feedback">
              {formik.errors.email}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="password" className="mb-3">
            <Form.Label className="form-label">
              {t`Password`} <span className="required">*</span>
            </Form.Label>
            <Form.Control
              type="password"
              name="password"
              value={formik.values.password}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              isInvalid={formik.touched.password && formik.errors.password}
              className="form-control"
            />
            <Form.Control.Feedback type="invalid" className="form-control-feedback">
              {formik.errors.password}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="username" className="mb-3">
            <Form.Label className="form-label">
              {t`Username`} <span className="required">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              name="username"
              value={formik.values.username}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              isInvalid={formik.touched.username && formik.errors.username}
              className="form-control"
            />
            <Form.Control.Feedback type="invalid" className="form-control-feedback">
              {formik.errors.username}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="firstName" className="mb-3">
            <Form.Label className="form-label">{t`First Name`}</Form.Label>
            <Form.Control
              type="text"
              name="firstName"
              value={formik.values.firstName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className="form-control"
            />
          </Form.Group>

          <Form.Group controlId="lastName" className="mb-3">
            <Form.Label className="form-label">{t`Last Name`}</Form.Label>
            <Form.Control
              type="text"
              name="lastName"
              value={formik.values.lastName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className="form-control"
            />
          </Form.Group>

          <Form.Group controlId="phoneNumber" className="mb-3">
            <Form.Label className="form-label">{t`Phone Number`}</Form.Label>
            <Form.Control
              type="text"
              name="phoneNumber"
              value={formik.values.phoneNumber}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              isInvalid={formik.touched.phoneNumber && formik.errors.phoneNumber}
              className="form-control"
            />
            <Form.Control.Feedback type="invalid" className="form-control-feedback">
              {formik.errors.phoneNumber}
            </Form.Control.Feedback>
          </Form.Group>

          <Button variant="primary" type="submit" className="submit-btn">
            {t`Register`}
          </Button>
        </Form>
      )}
    </Container>
  );
};

export default RegisterForm;
